import { call, select, takeLatest } from 'redux-saga/effects';
import { SAVE_SYSTEM_ACTOR } from '@control-front-end/common/constants/graphActors';
import { bindAttach } from '@control-front-end/common/sagas/attachUtils';
import { createActor } from './graphNodes';
import { createMassEdges } from './graphEdges';

function makeEventModel(data) {
  return {
    actorModel: {
      title: data.title,
      description: data.description,
      formData: {
        startDate: data.startDate,
        endDate: data.endDate,
        channel: data.channel,
      },
      appId: data.appId || null,
      appSettings: data.appSettings || null,
      cardActorId: data.cardActorId || null,
    },
    access: data.access.map((i) => ({
      action: i.userId === data.ownerId ? 'update' : 'create',
      data: {
        userId: i.userId,
        privs: i.privs,
      },
    })),
  };
}

const systemModels = {
  events: makeEventModel,
};

function* linkActors(actors, actorId) {
  const edgeTypes = yield select((state) => state.edgeTypes);
  const edgeTypeH = edgeTypes.find((i) => i.name === 'hierarchy');
  const edges = actors.map((i) => ({
    source: actorId,
    target: i.id,
    edgeTypeId: edgeTypeH.id,
  }));
  yield createMassEdges({ payload: { edges } });
}

function* saveSystemActor({ payload }) {
  const { formActions, actor, systemForm } = payload;
  const systemForms = yield select((state) => state.systemForms);
  const { actorModel, access } = systemModels[systemForm](actor);
  const eventActorsPayload = {
    formId: systemForms[systemForm].id,
    access,
    ...actorModel,
  };
  const newActor = yield createActor({ payload: eventActorsPayload });
  const attaches = actor.attachments || [];
  yield call(bindAttach, attaches, newActor.id);
  if (actor.actors) {
    yield call(linkActors, actor.actors, newActor.id);
  }
  formActions.setSubmitting(false);
  if (formActions.callback) formActions.callback(newActor);
}

function* systemActors() {
  yield takeLatest(SAVE_SYSTEM_ACTOR.REQUEST, saveSystemActor);
}

export default systemActors;
